import { MacroRegion } from "../../enum/MacroRegion";

export const macroRegionLimits: { [index: string]: number[][][] } = {
  [MacroRegion.ALL_SAINTS_BAY]: [
    [
      [-36.45, -8.78],
      [-41.2, -8.78],
      [-41.2, -14.95],
      [-36.45, -14.95],
      [-36.45, -8.78],
    ],
  ],
  [MacroRegion.PATOS_LAGOON]: [
    [
      [-52.405110714212924, -34.675190535310016],
      [-47.98581065720407, -35.21629315665815],
      [-47.05055460524292, -31.847559269700206],
      [-46.558242013513194, -29.392726521220325],
      [-49.049146386261754, -29.514770057871075],
      [-53.52023093722407, -28.78950472773306],
      [-55.37704973873305, -30.985712829900834],
      [-54.339608558513575, -33.12961502264914],
      [-52.405110714212924, -34.675190535310016],
    ],
  ],
  [MacroRegion.PORT_OF_ACU]: [
    [
      [-41.85, -21.0],
      [-41.85, -23.38],
      [-40.0, -23.38],
      [-40.0, -21.0],
      [-41.85, -21.0],
    ],
  ],
  [MacroRegion.PORT_OF_ITAGUAI]: [
    [
      [-45.118, -24.901033629484573],
      [-43.511061639298106, -24.901033629484573],
      [-43.511061639298106, -22.27253079949385],
      [-45.118, -22.27253079949385],
      [-45.118, -24.901033629484573],
    ],
  ],
  [MacroRegion.PORT_OF_ITAJAI]: [
    [
      [-46.52104471070345, -26.46622540562123],
      [-50.232416871535804, -26.46622540562123],
      [-50.232416871535804, -29.318565778986645],
      [-46.52104471070345, -29.318565778986645],
      [-46.52104471070345, -26.46622540562123],
    ],
  ],
  [MacroRegion.PORT_OF_PARANAGUA]: [
    [
      [-49.449308645935474, -25.99233236210516],
      [-47.228544136675595, -25.974269387448516],
      [-45.65323284168585, -26.703961345275246],
      [-44.91577962160332, -25.878365201704725],
      [-45.742491259209885, -24.915923736152095],
      [-46.49971869913591, -24.916761228769758],
      [-49.44767742255982, -24.915469503697594],
      [-49.449308645935474, -25.99233236210516],
    ],
  ],
  [MacroRegion.PORT_OF_SANTOS]: [
    [
      [-50.06, -24.91],
      [-45.11942, -24.91],
      [-45.11942, -20.07],
      [-50.06, -20.07],
      [-50.06, -24.91],
    ],
  ],
  [MacroRegion.RIVER_RHINE_GERMANY]: [
    [
      [6.3061523437, 51.31688050404],
      [6.6357421875, 50.68079714532],
      [7.1630859374, 50.19096776558],
      [7.6025390625, 49.74578130615],
      [7.8662109375, 49.41812070066],
      [7.7893066406, 48.90083790234],
      [7.5201416015, 48.51296552999],
      [7.3773193359, 48.09275716032],
      [7.9376220703, 48.02299832104],
      [8.4539794921, 48.29781249243],
      [8.8549804687, 49.11343354595],
      [8.9758300781, 49.66762782262],
      [8.7176513671, 50.31390041107],
      [7.8112792968, 50.8128770103],
      [6.8334960937, 51.56341232867],
      [6.3061523437, 51.31688050404],
    ],
  ],
  [MacroRegion.PORT_OF_ROTTERDAM]: [
    [
      [2.5, 51.6],
      [6.0, 51.6],
      [6.0, 53.05],
      [2.5, 53.05],
      [2.5, 51.6],
    ],
  ],
  [MacroRegion.PORT_OF_PECEM]: [
    [
      [-40.95, -2.05],
      [-40.95, -5.025],
      [-37.82, -5.025],
      [-37.82, -2.05],
      [-40.95, -2.05],
    ],
  ],
  [MacroRegion.PORT_OF_SINES]: [
    [
      [-7.3828125, 36.8268747],
      [-7.3608398, 42.1634034],
      [-10.788574, 42.2285173],
      [-10.788574, 36.8268747],
      [-7.3828125, 36.8268747],
    ],
  ],
  [MacroRegion.COAST_OF_BELGIUM]: [
    [
      [2.5045136423212, 51.59492822186348],
      [2.5045136423212, 50.77126263643268],
      [4.870696302291805, 50.77126263643268],
      [4.870696302291805, 51.59492822186348],
      [2.5045136423212, 51.59492822186348],
    ],
  ],
  [MacroRegion.GERMAN_NORTH_SEA]: [
    [
      [6, 55.85],
      [6, 54.5],
      [9, 54.5],
      [9, 55.85],
      [6, 55.85],
    ],
  ],
  [MacroRegion.DANISH_NORTH_SEA]: [
    [
      [6, 55.851],
      [9, 55.851],
      [9, 57.1],
      [6, 57.1],
      [6, 55.851],
    ],
  ],
  [MacroRegion.SCOTLAND_NORTH_SEA]: [
    [
      [-2.75, 57.5],
      [-2.75, 56.3],
      [-0.5, 56.3],
      [-0.5, 57.5],
      [-2.75, 57.5],
    ],
  ],
  [MacroRegion.SOUTHERN_BIGHT_NORTH_SEA]: [
    [
      [5, 53],
      [0.25, 53],
      [0.25, 50.5],
      [5, 50.5],
      [5, 53],
    ],
  ],
  [MacroRegion.NORDLICHT_AREA_NORTH_SEA]: [
    [
      [8.799, 54.499],
      [5.201, 54.499],
      [5.230, 53.320],
      [8.770, 53.330],
      [8.799, 54.499],
    ],
  ],
  [MacroRegion.IRISH_SEA]: [
    [
      [-2.7, 52.4],
      [-2.7, 55.5],
      [-7.2, 55.5],
      [-7.2, 52.4],
      [-2.7, 52.4],
    ],
  ],
  [MacroRegion.BALTIC_SEA]: [
    [
      [10.8, 56.3],
      [10.8, 54.1],
      [15.9, 54.1],
      [15.9, 56.3],
      [10.8, 56.3],
    ],
  ],
  [MacroRegion.COAST_OF_ESP_SANTO]: [
    [
      [-41.02242581569641, -20.776100559942563],
      [-39.12197714919273, -20.776100559942563],
      [-39.12197714919273, -19.159141736806234],
      [-41.02242581569641, -19.159141736806234],
      [-41.02242581569641, -20.776100559942563],
    ],
  ],
  [MacroRegion.COAST_OF_IQUIQUE]: [
    [
      [-74, -17.0],
      [-74, -21.495],
      [-69.7, -21.495],
      [-69.7, -17.0],
      [-74, -17.0],
    ],
  ],
  [MacroRegion.COAST_OF_ANTOFAGASTA]: [
    [
      [-74.0, -21.5],
      [-74.0, -26.0],
      [-69.7, -26.0],
      [-69.7, -21.5],
      [-74.0, -21.5],
    ],
  ],
  [MacroRegion.COAST_OF_BARQUITO]: [
    [
      [-74.0, -26.01],
      [-74.0, -27.6],
      [-69.7, -27.6],
      [-69.7, -26.01],
      [-74.0, -26.01],
    ],
  ],
  [MacroRegion.COAST_OF_GUACOLDA]: [
    [
      [-74, -27.61],
      [-74, -30.5],
      [-69.7, -30.5],
      [-69.7, -27.61],
      [-74, -27.61],
    ],
  ],
  [MacroRegion.COAST_OF_VALPARAISO]: [
    [
      [-74.7, -37.6],
      [-70.4, -37.6],
      [-70.4, -31],
      [-74.7, -31],
      [-74.7, -37.6],
    ],
  ],
  [MacroRegion.BARRA_NORTE]: [
    [
      [-50.79973997453524, 2.4524215891347865],
      [-54.378630521032136, -0.6353338040624834],
      [-54.88441841016892, -1.3432829495417309],
      [-54.970789154659684, -4.698519715844242],
      [-52.90155098595197, -2.0373802513448],
      [-50.27346546332683, -1.0801975275516043],
      [-48.39762460023695, -0.2150521539113015],
      [-47.904558145378786, 0.6675479333829912],
      [-47.784469951824605, 1.7777206016641571],
      [-48.94947394372704, 2.2369355826132136],
      [-50.79973997453524, 2.4524215891347865],
    ],
  ],
  [MacroRegion.SAO_FRANCISCO_DO_SUL]: [
    [
      [-47.54, -26.0],
      [-50.23, -26.0],
      [-50.23, -26.45],
      [-47.54, -26.45],
      [-47.54, -26.0],
    ],
  ],
  [MacroRegion.SOUTH_BAHIA]: [
    [
      [-40.2, -15.0],
      [-40.2, -17.1],
      [-37.4, -17.1],
      [-37.4, -15.0],
      [-40.2, -15.0],
    ],
  ],
  [MacroRegion.COAST_OF_ALAGOAS]: [
    [
      [-36.44, -8.78],
      [-36.44, -11.61],
      [-34.45, -11.61],
      [-34.45, -8.78],
      [-36.44, -8.78],
    ],
  ],
  [MacroRegion.COAST_OF_PERNAMBUCO]: [
    [
      [-37.83, -6.76],
      [-37.83, -8.75],
      [-33.45, -8.75],
      [-33.45, -6.76],
      [-37.83, -6.76],
    ],
  ],
  [MacroRegion.COAST_OF_RIO_GRANDE_DO_NORTE]: [
    [
      [-37.81, -3.67],
      [-37.81, -6.75],
      [-34.2, -6.75],
      [-34.2, -3.67],
      [-37.81, -3.67],
    ],
  ],
  [MacroRegion.COAST_OF_PIAUI]: [
    [
      [-40.96, -5.239],
      [-40.96, -2.045],
      [-42.89, -2.045],
      [-42.89, -5.239],
      [-40.96, -5.239],
    ],
  ],
  [MacroRegion.COAST_OF_MARANHAO]: [
    [
      [-42.9, -5.063],
      [-42.9, -0.645],
      [-46.145, -0.645],
      [-46.145, -5.063],
      [-42.9, -5.063],
    ],
  ],
  [MacroRegion.COAST_OF_PARA]: [
    [
      [-52.770941871560794, -2.1405905123274067],
      [-54.33812755173969, -4.052672419893327],
      [-54.98767708207889, -4.7986123489388035],
      [-47.61545922697846, -4.822082611005001],
      [-46.32678746496455, -2.7517473443160583],
      [-46.2234069983665, -0.34579683203558886],
      [-46.21560017078011, 1.0124794250577054],
      [-47.73763758397547, 1.7234243531479052],
      [-47.88550076987002, 0.5021993737096011],
      [-48.36123449840085, -0.23068066794381537],
      [-51.76851553435361, -1.7925945902017872],
      [-52.770941871560794, -2.1405905123274067],
    ],
  ],
  [MacroRegion.COAST_OF_RIO_DE_JANEIRO]: [
    [
      [-43.50939808028431, -24.308435464336],
      [-41.851, -24.308435464336],
      [-41.851, -22.238819947362515],
      [-43.50939808028431, -22.238819947362515],
      [-43.50939808028431, -24.308435464336],
    ],
  ],
  [MacroRegion.BELO_HORIZONTE]: [
    [
      [-45.3, -18.9],
      [-45.3, -21],
      [-42.5, -21],
      [-42.5, -18.9],
      [-45.3, -18.9],
    ],
  ],
  [MacroRegion.MATO_GROSSO_DO_SUL]: [
    [
      [-56.12, -17.89],
      [-56.12, -22.18],
      [-51.49, -22.18],
      [-51.49, -17.89],
      [-56.12, -17.89],
    ],
  ],
  [MacroRegion.MATO_GROSSO]: [
    [
      [-54.12, -11.65],
      [-54.12, -15.76],
      [-49.65, -15.76],
      [-49.65, -11.65],
      [-54.12, -11.65],
    ],
  ],
  [MacroRegion.PERU_NORTE]: [
    [
      [-82.4, -3.3],
      [-82.4, -9.9],
      [-77.5, -9.9],
      [-77.5, -3.3],
      [-82.4, -3.3],
    ],
  ],
  [MacroRegion.PERU_CENTRAL]: [
    [
      [-80, -9.901],
      [-80, -14.65],
      [-75, -14.65],
      [-75, -9.901],
      [-80, -9.901],
    ],
  ],
  [MacroRegion.PERU_SUL]: [
    [
      [-76, -14.655],
      [-76, -18.02],
      [-70, -18.02],
      [-70, -14.655],
      [-76, -14.655],
    ],
  ],
  [MacroRegion.AMAZON_RIVER]: [
    [
      [-70.0, -5.0],
      [-55.0, -5.0],
      [-55.0, 1.0],
      [-70.0, 1.0],
      [-70.0, -5.0],
    ],
  ],
  [MacroRegion.PORT_OF_PIRAEUS]: [
    [
      [22.7, 38.8],
      [22.7, 37.2],
      [25.3, 37.2],
      [25.3, 38.8],
      [22.7, 38.8],
    ],
  ],
};
